import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import UserDashboard from './pages/UserDashboard';
import TrainingDetails from './pages/TrainingDetails';
import ObjectiveAssessment from './pages/ObjectiveAssessment';
import CompletedAssessments from './pages/CompletedAssessments';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import StakeholderRoute from './components/StakeholderRoute';
import StakeholderDashboard from './pages/StakeholderDashboard';
import StakeholderProgramProgress from './pages/StakeholderProgramProgress';
import AdminDashboard from './pages/AdminDashboard';
import CreateObjectiveProgram from './pages/CreateObjectiveProgram';
import EditProgram from './pages/EditProgram';
import CreateSubjectiveProgram from './pages/CreateSubjectiveProgram';
import CreateProgramTabs from './pages/CreateProgramTabs';
import SubjectiveAssessment from './pages/SubjectiveAssessment';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import TrainerLedTrainingDetails from './pages/TrainerLedTrainingDetails';
import BulkEvaluationPage from './pages/BulkEvaluationPage';
import CloneProgram from './pages/CloneProgram';

const { Content } = Layout;

const App: React.FC = () => {
  const location = useLocation();

  // Hide header on assessment pages to prevent distraction/navigation
  const isAssessmentPage = location.pathname.startsWith('/assessment') ||
    location.pathname.startsWith('/assessment-objective');

  return (
    <ProtectedRoute>
      <Layout style={{ height: '100vh' }}>
        {!isAssessmentPage && <Header />}
        <Content style={{ overflow: 'auto' }}>
          <Routes>
            <Route path="/" element={<UserDashboard />} />
            <Route path="/training/:trainingId" element={<TrainingDetails />} />
            <Route path="/assessment-objective/:trainingId" element={<ObjectiveAssessment />} />
            <Route path="/assessment/:trainingId" element={<SubjectiveAssessment />} />
            <Route path="/completed" element={<CompletedAssessments />} />
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/create-objective" element={<AdminRoute><CreateObjectiveProgram /></AdminRoute>} />
            <Route path="/admin/create" element={<AdminRoute><CreateProgramTabs /></AdminRoute>} />
            <Route path="/admin/edit/:id" element={<AdminRoute><EditProgram /></AdminRoute>} />
            <Route path="/admin/clone/:trainingId" element={<AdminRoute><CloneProgram /></AdminRoute>} />
            <Route path="/admin/executive-dashboard" element={<AdminRoute><ExecutiveDashboard /></AdminRoute>} />
            <Route path="/trainer-led-training-details/:trainingId" element={<TrainerLedTrainingDetails />} />
            <Route path="/trainer-led-training-details/:trainingId/bulk-evaluate/:assignmentId" element={<BulkEvaluationPage />} />
            <Route path="/stakeholder" element={<StakeholderRoute><StakeholderDashboard /></StakeholderRoute>} />
            <Route path="/stakeholder/:trainingId" element={<StakeholderRoute><StakeholderProgramProgress /></StakeholderRoute>} />
          </Routes>
        </Content>
      </Layout>
    </ProtectedRoute>
  );
};

export default App;